import { render, staticRenderFns } from "./CategoriaMesa.vue?vue&type=template&id=50bf7c2c&scoped=true&"
import script from "./CategoriaMesa.vue?vue&type=script&lang=js&"
export * from "./CategoriaMesa.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaMesa.vue?vue&type=style&index=0&id=50bf7c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf7c2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
